import { FunctionComponent } from 'react';
import styled from 'styled-components';

import theme from '@/styles/theme';
import { DIRECTION } from '@/types/common';

interface NarrowCaretProps {
  direction?: DIRECTION;
  size?: number;
  color?: string;
}

/**
 * @default
 * direction: DIRECTION.BOTTOM,
 * color: theme.color.gray900,
 * size: 16,
 */

const NarrowCaret: FunctionComponent<NarrowCaretProps> = ({
  direction = DIRECTION.BOTTOM,
  size = 16,
  color = theme.color.gray900,
}) => {
  return (
    <CaretSVG
      width={size}
      height={size}
      direction={direction}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.3594 5.40039L8.03125 8.82227L4.70312 5.40039L3.75 6.32227L8.03125 10.7285L12.3125 6.32227L11.3594 5.40039Z'
        fill={color}
      />
    </CaretSVG>
  );
};

export default NarrowCaret;

const CaretSVG = styled.svg<{ direction: DIRECTION }>`
  transition: transform 0.1s linear;
  transform: rotate(
    ${({ direction }) =>
      direction === DIRECTION.TOP
        ? -180
        : direction === DIRECTION.LEFT
          ? 90
          : direction === DIRECTION.RIGHT
            ? -90
            : 0}deg
  );
`;
